import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Navbar,
  Nav,
  Card,
  Badge,
  Image,
  Offcanvas,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Navigate, useNavigate } from "react-router-dom";
import {
  FaWhatsapp,
  FaFilePdf,
  FaShippingFast,
  FaPlane,
  FaShip,
  FaRocket,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaUserPlus,
  FaShoppingCart,
  FaWarehouse,
  FaHome,
  FaGift,
  FaCheckCircle,
  FaExclamationTriangle,
  FaDollarSign,
  FaHeadset,
  FaInstagram,
  FaFacebook,
  FaTiktok,
  FaShareAlt,
  FaClock,
  FaBox,
  FaMapMarkedAlt,
  FaTag,
  FaCreditCard,
  FaTruck,
  FaBoxOpen,
  FaLock,
  FaSmile,
  FaCalendarAlt,
  FaArrowUp,
  FaArrowDown,
  FaChevronRight,
  FaTimes,
  FaPlayCircle,
  FaPlay,
  FaBoxes,
  FaPallet,
  FaPlaneDeparture,
} from "react-icons/fa";

import { Player } from "@lottiefiles/react-lottie-player";
import { motion } from "framer-motion";

import inicio from "../../assets/inicio.png";
import logoMbox from "../../assets/MBOX-LOGO-BLANCO.png";
import video1 from "../../assets/Video1.mp4";
import video2 from "../../assets/Video2.mp4";
import video3 from "../../assets/video3.mp4";
import video4 from "../../assets/video4.mp4";

import mboxitoMexico from "../../assets/mboxitoMexico.png";
import mboxitoEEUU from "../../assets/mboxitoEEUU.png";

import deliveryAnim from "../../assets/Animation - 1748224957909.json";
import mascota from "../../assets/MBOXITO_MASCOTA.png";
import trackingAnimation from "../../assets/Animation - 1747624631532.json";
import boxAnimation from "../../assets/Animation - 1747626198371.json";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";


const BenefitsSection = (props) => {
  const tiendas = [
    { nombre: "Amazon", logo: "https://www.google.com/s2/favicons?domain=amazon.com&sz=128", url: "https://www.amazon.com/" },
    { nombre: "Walmart", logo: "https://www.google.com/s2/favicons?domain=walmart.com&sz=128", url: "https://www.walmart.com/" },
    { nombre: "eBay", logo: "https://www.google.com/s2/favicons?domain=ebay.com&sz=128", url: "https://www.ebay.com/" },
    { nombre: "Target", logo: "https://www.google.com/s2/favicons?domain=target.com&sz=128", url: "https://www.target.com/" },
    { nombre: "Shein", logo: "https://www.google.com/s2/favicons?domain=shein.com&sz=128", url: "https://www.shein.com/" },
    { nombre: "Temu", logo: "https://www.google.com/s2/favicons?domain=temu.com&sz=128", url: "https://www.temu.com/" },
    { nombre: "Nike", logo: "https://www.google.com/s2/favicons?domain=nike.com&sz=128", url: "https://www.nike.com/" },
    { nombre: "Apple", logo: "https://www.google.com/s2/favicons?domain=apple.com&sz=128", url: "https://www.apple.com/" },
    { nombre: "Alibaba", logo: "https://www.google.com/s2/favicons?domain=alibaba.com&sz=128", url: "https://www.alibaba.com/" },
    { nombre: "Best Buy", logo: "https://www.google.com/s2/favicons?domain=bestbuy.com&sz=128", url: "https://www.bestbuy.com/" },
    { nombre: "Home Depot", logo: "https://www.google.com/s2/favicons?domain=homedepot.com&sz=128", url: "https://www.homedepot.com/" },
    { nombre: "Macy's", logo: "https://www.google.com/s2/favicons?domain=macys.com&sz=128", url: "https://www.macys.com/" },
    { nombre: "Kohl's", logo: "https://www.google.com/s2/favicons?domain=kohls.com&sz=128", url: "https://www.kohls.com/" },
    { nombre: "Etsy", logo: "https://www.google.com/s2/favicons?domain=etsy.com&sz=128", url: "https://www.etsy.com/" },
    { nombre: "Wayfair", logo: "https://www.google.com/s2/favicons?domain=wayfair.com&sz=128", url: "https://www.wayfair.com/" },
    { nombre: "Overstock", logo: "https://www.google.com/s2/favicons?domain=overstock.com&sz=128", url: "https://www.overstock.com/" },
    { nombre: "Costco", logo: "https://www.google.com/s2/favicons?domain=costco.com&sz=128", url: "https://www.costco.com/" },
    { nombre: "Samsung", logo: "https://www.google.com/s2/favicons?domain=samsung.com&sz=128", url: "https://shop.samsung.com/us/" },
    { nombre: "Adidas", logo: "https://www.google.com/s2/favicons?domain=adidas.com&sz=128", url: "https://www.adidas.com/us" },
    { nombre: "Wish", logo: "https://www.google.com/s2/favicons?domain=wish.com&sz=128", url: "https://www.wish.com/" }
  ];
  return (
    <section id='beneficios' className='py-5 position-relative'>
          <Container>
            <Row className='justify-content-center mb-5'>
              <Col lg={8} className='text-center'>
                <Badge bg='primary' className='mb-3 fw-normal fs-6'>
                  VENTAJAS EXCLUSIVAS
                </Badge>
                <h2 className='display-5 fw-bold mb-3'>
                  Beneficios{" "}
                  <span style={{ color: "#182848" }}>MBOX Express</span>
                </h2>
                <p className='lead text-muted'>
                  Más que un servicio de envíos, una solución completa para tus
                  compras internacionales
                </p>
              </Col>
            </Row>

            <Row className='g-4'>
              {/* Beneficio 1 */}
              <Col md={6} lg={4}>
                <Card className='border-0 shadow-sm h-100 hover-effect-benefit'>
                  <Card.Body className='p-4'>
                    <div className='d-flex align-items-start mb-3'>
                      <div className='bg-light-primary text-primary rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center p-3 me-3'>
                        <FaBox size={20} />
                      </div>
                      <div>
                        <h4 className='mb-2'>Casillero Gratis en Miami</h4>
                        <p className='text-muted mb-0'>
                          Abre tu casillero sin costo y recibe paquetes sin
                          límite de peso, tamaño o valor comercial
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Beneficio 2 */}
              <Col md={6} lg={4}>
                <Card className='border-0 shadow-sm h-100 hover-effect-benefit'>
                  <Card.Body className='p-4'>
                    <div className='d-flex align-items-start mb-3'>
                      <div className='bg-light-primary text-primary rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center p-3 me-3'>
                        <FaMapMarkedAlt size={20} />
                      </div>
                      <div>
                        <h4 className='mb-2'>Seguimiento en Tiempo Real</h4>
                        <p className='text-muted mb-0'>
                          Rastrea tus paquetes desde Miami hasta tu hogar con
                          nuestro sistema de tracking
                        </p>
                      </div>
                    </div>
                    <Button
                      variant='outline-primary'
                      target='_blank'
                      rel='noreferrer'
                      href='https://mbox-hn.com/seguimiento'
                      size='sm'
                      className='mt-2'
                      style={{ borderRadius: "20px" }}
                    >
                      Rastrear mi envío
                    </Button>
                  </Card.Body>
                </Card>
              </Col>

              {/* Beneficio 3 */}
              <Col md={6} lg={4}>
                <Card className='border-0 shadow-sm h-100 hover-effect-benefit'>
                  <Card.Body className='p-4'>
                    <div className='d-flex align-items-start mb-3'>
                      <div className='bg-light-primary text-primary rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center p-3 me-3'>
                        <FaTag size={20} />
                      </div>
                      <div>
                        <h4 className='mb-2'>Descuentos Exclusivos</h4>
                        <p className='text-muted mb-0'>
                          Precios especiales para emprendedores, estudiantes y
                          empresas afiliadas
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Beneficio 4 */}
              <Col md={6} lg={4}>
                <Card className='border-0 shadow-sm h-100 hover-effect-benefit'>
                  <Card.Body className='p-4'>
                    <div className='d-flex align-items-start mb-3'>
                      <div className='bg-light-primary text-primary rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center p-3 me-3'>
                        <FaGift size={20} />
                      </div>
                      <div>
                        <h4 className='mb-2'>Reempaque Gratuito</h4>
                        <p className='text-muted mb-0'>
                          Unificamos tus paquetes para reducir volumen y
                          ahorrarte en costos de envío
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Beneficio 5 */}
              <Col md={6} lg={4}>
                <Card className='border-0 shadow-sm h-100 hover-effect-benefit'>
                  <Card.Body className='p-4'>
                    <div className='d-flex align-items-start mb-3'>
                      <div className='bg-light-primary text-primary rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center p-3 me-3'>
                        <FaCreditCard size={20} />
                      </div>
                      <div>
                        <h4 className='mb-2'>
                          Usa Nuestra Tarjeta Para Las Compras
                        </h4>
                        <p className='text-muted mb-0'>
                          Compra en tiendas internacionales incluso sin tarjeta
                          de crédito
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Beneficio 6 */}
              <Col md={6} lg={4}>
                <Card className='border-0 shadow-sm h-100 hover-effect-benefit'>
                  <Card.Body className='p-4'>
                    <div className='d-flex align-items-start mb-3'>
                      <div className='bg-light-primary text-primary rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center p-3 me-3'>
                        <FaTruck size={20} />
                      </div>
                      <div>
                        <h4 className='mb-2'>Entrega a Domicilio</h4>
                        <p className='text-muted mb-0'>
                          Recibe tus paquetes en casa en Tegucigalpa y áreas
                          metropolitanas
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <div className='my-10 px-4 mt-4'>
              <h2 className='text-2xl font-bold text-center mb-4'>
                Tiendas en las que puedes comprar
              </h2>
              <Swiper
                modules={[Autoplay]}
                spaceBetween={30}
                slidesPerView={3}
                loop={true}
                autoplay={{ delay: 2000, disableOnInteraction: false }}
                breakpoints={{
                  640: { slidesPerView: 3 },
                  768: { slidesPerView: 4 },
                  1024: { slidesPerView: 5 },
                }}
              >
                {tiendas.map((tienda, index) => (
                  <SwiperSlide
                    key={index}
                    className='flex items-center justify-center p-4'
                  >
                    <a
                      href={tienda.url}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='block'
                    >
                      <div
                        className='flex items-center justify-center mx-auto overflow-hidden'
                        style={{ width: 100, height: 50 }}
                      >
                        <img
                          src={tienda.logo}
                          alt={`Logo de ${tienda.nombre}`}
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain",
                          }}
                          className='transition duration-300'
                        />
                      </div>
                    </a>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            {/* CTA Section */}
            <Row className='mt-5'>
              <Col className='text-center'>
                <div className='bg-primary text-white p-4 rounded-3'>
                  <h3 className='mb-3'>¿Listo para comenzar?</h3>
                  <p className='lead mb-4 text-white-50'>
                    Regístrate ahora y disfruta de todos estos beneficios
                  </p>
                  <Button
                    variant='light'
                    size='lg'
                    href='https://mbox-hn.com/crear-casillero'
                    className='fw-bold px-4 shadow-sm'
                    style={{
                      borderRadius: "8px",
                      color: "#182848",
                    }}
                  >
                    <FaUserPlus className='me-2' /> Crear mi Casillero Gratis
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
  );
};

export default BenefitsSection;
